import {DOCUMENT_TYPE_BANK_FRONTPAGE} from '@/modules/finkn/field-of-area/bank/frontpage/sanity/constants';
import {DOCUMENT_TYPE_COLLECTION_FRONTPAGE} from '@/modules/finkn/field-of-area/collection/frontpage/sanity/constants';
import {DOCUMENT_TYPE_INSURANCE_FRONTPAGE} from '@/modules/finkn/field-of-area/insurance/frontpage/sanity/constants';
import type {ContentBlocksFragment} from '@/modules/foundation/sanity/content-blocks/query';
import {PORTABLE_TEXT_FRAGMENT} from '@/modules/foundation/sanity/portable-text/query';

import {DOCUMENT_TYPE_NEMND} from '../constants';

import type {BLOCK_TYPE_NEMND_LIST_ALL} from './constants';

const NEMND_DETAILS_FRAGMENT = `//groq
	_id,
	name,
	slug,
	description,
	icon
`;

export const NEMND_LIST_ALL_FRAGMENT = `//groq
	...,
	description[]{
		${PORTABLE_TEXT_FRAGMENT}
	},
	"nemnds": *[(_type == "${DOCUMENT_TYPE_NEMND}")] {
			${NEMND_DETAILS_FRAGMENT}
		},
	filter == "all" => {
		"nemnds": *[(_type == "${DOCUMENT_TYPE_NEMND}")]|order(orderRank) {
			${NEMND_DETAILS_FRAGMENT}
		}
	},
	filter == "${DOCUMENT_TYPE_INSURANCE_FRONTPAGE}" => {
		"nemnds": *[(_type == "${DOCUMENT_TYPE_NEMND}" && fieldOfArea->._type == "${DOCUMENT_TYPE_INSURANCE_FRONTPAGE}")]|order(orderRank) {
			${NEMND_DETAILS_FRAGMENT}
		}
	},
	filter == "${DOCUMENT_TYPE_BANK_FRONTPAGE}" => {
		"nemnds": *[(_type == "${DOCUMENT_TYPE_NEMND}" && fieldOfArea->._type == "${DOCUMENT_TYPE_BANK_FRONTPAGE}")]|order(orderRank) {
			${NEMND_DETAILS_FRAGMENT}
		}
	},
	filter == "${DOCUMENT_TYPE_COLLECTION_FRONTPAGE}" => {
		"nemnds": *[(_type == "${DOCUMENT_TYPE_NEMND}" && fieldOfArea->._type == "${DOCUMENT_TYPE_COLLECTION_FRONTPAGE}")]|order(orderRank) {
			${NEMND_DETAILS_FRAGMENT}
		}
	}
`;

export type NemndListAllFragment = Extract<
	ContentBlocksFragment[number],
	{_type: typeof BLOCK_TYPE_NEMND_LIST_ALL}
>;
